module.exports = __webpack_public_path__ + "img/movieTheater-2.5f047e88.jpg";